import { routes } from '../config/api_routes'

export const customerService = {

    getCustomer: (formData) => window.axios.post(routes.getCustomerApi,formData),

    //getCustomerCredit: (formData) => window.axios.post(routes.getCustomerCreditApi,formData),

    customerExportCsv: (formData) => window.axios.post(routes.customerExportToCsvApi, formData),

    getCustomerProfile: (formData) => window.axios.post(routes.getCustomerProfileApi,formData),

    updateCustomerProfile: (formData) => window.axios.post(routes.updateCustomerProfileApi,formData),

    getCustomerOrder: (formData) => window.axios.post(routes.getCustomerOrderApi,formData),

    changeCustPassword: (formData) => window.axios.post(routes.changeCusPasswordApi,formData),

    addCustomer: (formData) => window.axios.post(routes.addCustomerApi,formData),

    changeCustomerStatus: (formData) => window.axios.post(routes.changeCustomerStatusApi,formData),

    deleteCustomer: (formData) => window.axios.post(routes.deleteCustomerApi,formData),

    unblockCustomer: (formData) => window.axios.post(routes.unblockCustomerApi,formData),

    getCustomerList: (formData) => window.axios.post(routes.getCustomerOrdersApi,formData),

    getCustomerTypeList: (formData) => window.axios.post(routes.getCustomerTypeApi,formData),

    getB2bCutomerProducts: (formData) => window.axios.post(routes.getB2bCutomerProductsApi,formData),

    individualSubProductSave: (formData) => window.axios.post(routes.individualSubProductSave,formData),
}